import React from 'react';
import PropTypes from 'prop-types';
import { FRANCHISE_SECTIONS } from './franchiseSections';
import { scrollToSection } from './useFranchiseScrollSpy';

export function FranchiseAside({ activeSectionId }) {
  const handleClick = (id) => (event) => {
    event.preventDefault();
    scrollToSection(id);
  };

  return (
    <div className="aside franchise-aside">
      <nav className="franchise-aside__nav" aria-label="Содержание лендинга">
        <ul className="franchise-aside__list">
          {FRANCHISE_SECTIONS.map(({ id, title }) => (
            <li
              key={id}
              className={`franchise-aside__item ${activeSectionId === id ? 'is-active' : ''}`}
            >
              <a
                href={`#${id}`}
                className="franchise-aside__link"
                onClick={handleClick(id)}
              >
                <span className="franchise-aside__bar" aria-hidden />
                <span className="franchise-aside__title">{title}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

FranchiseAside.propTypes = {
  activeSectionId: PropTypes.string.isRequired,
};
